import React, { useEffect, useState } from 'react'

import cx from 'classnames'
import moment from 'moment'

import { EndUser } from '@driftt/api-types'
import { Div, Span,ToolTip } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import Card from 'components/Card'

import { segmentTrack,TrackType } from '../../../utils/tracking'

import styles from './styles.module.css'

interface Props {
  user: EndUser | undefined
  personalIntel: any
  unifiedAttributes: any
}

const TOOLTIP_TEXT = 'Click to copy email'

const AboutContactSection = (props: Props) => {
  const [isOpen, setIsOpen] = useState(true)
  const { user, personalIntel, unifiedAttributes } = props
  const [tooltipText, setTooltipText] = useState(TOOLTIP_TEXT)

  const userLocation = personalIntel?.displayLocation || user?.attributes?.location

  const handleCopyEmail = () => {
    if (user?.email) {
      segmentTrack(TrackType.CONTACT_DETAILS_COPY_EMAIL)
      navigator.clipboard.writeText(user.email).then(() => setTooltipText('Copied!'))
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setTooltipText(TOOLTIP_TEXT)
    }, 3000)
    return () => clearTimeout(timer)
  }, [tooltipText])

  return (
    <Card>
      <Div className={styles.sectionHeader}>
        <Div className={styles.iconHeader}>
          <Div>About {user?.name?.split(' ')?.[0]}</Div>
        </Div>
        <Div className={styles.collapseIcon} onClick={() => setIsOpen(!isOpen)}>
          <Icon name={isOpen ? 'chevron-down' : 'chevron-up'} width={12} />
        </Div>
      </Div>
      {isOpen && (
        <Div className={styles.sectionContent}>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Email</Div>
            {user?.email ? (
              <ToolTip
                render={() => user?.email && tooltipText}
                className={styles.tooltipWrapper}
                flow="up">
                <Div
                  className={cx(styles.contactField, styles.iconField, styles.pointer)}
                  onClick={handleCopyEmail}>
                  <Span className={styles.contactText}>{user?.email}</Span>
                </Div>
              </ToolTip>
            ) : (
              <Div>−</Div>
            )}
          </Div>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Phone</Div>
            <Div>{user?.attributes?.phone_number || '−'}</Div>
          </Div>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Location</Div>
            <Div>{userLocation || '−'}</Div>
          </Div>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Lead stage</Div>
            <Div>{unifiedAttributes?.leadStage?.value || '−'}</Div>
          </Div>
          <Div className={styles.field}>
            <Div className={styles.fieldLabel}>Last active</Div>
            {unifiedAttributes?.lastActive?.value ? (
              <ToolTip
                tethered
                render={() => moment(unifiedAttributes?.lastActive?.value).fromNow()}
                flow="up">
                <Div>{moment(unifiedAttributes?.lastActive?.value).format('MMM Do h:mm:ss a')}</Div>
              </ToolTip>
            ) : (
              <Div>−</Div>
            )}
          </Div>
        </Div>
      )}
    </Card>
  )
}

export default AboutContactSection
